import { formatDateToString } from '~/helpers'

const ProductDate: React.FC<{ date: string }> = ({ date }) => (
  <p className="lh-1 mb-0">
    <small>{formatDateToString(date)}</small>
  </p>
)

export default ProductDate
